module.exports = __webpack_public_path__ + "static/img/1.dff20fbf.jpg";